import "../components.css";

export default function Loading() {

    return(
        <div
            style={{
                padding: '2rem',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
        <span className="loader"></span>
        </div>
    );
}